// extracted by mini-css-extract-plugin
module.exports = {"container":"Announcement_container__3CVJo","content":"Announcement_content__2GpLG"};